import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js'; // Ensure the correct path to App.js
import reportWebVitals from './reportWebVitals.js';

import { AuthProvider } from './contexts/AuthContext.jsx'; // Auth provider context
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from './components/ErrorBoundary.jsx'; // Error boundary for catching errors

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <ErrorBoundary>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </ErrorBoundary>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals(console.log);
